import React from "react";

export function LoadingState({ label = "Loading…", testid = "phx-loading-state" }) {
  return (
    <div data-testid={testid} className="flex items-center justify-center p-10">
      <span className="text-xs uppercase tracking-[var(--phx-tracking)] font-semibold text-[var(--phx-slate-500)]">
        {label}
      </span>
    </div>
  );
}
